$optimade_zero $mol_book2_catalog
	Menu_title <= Logo_link $mol_link
		uri \
		title \−273.15°C
	param \page
	plugins /
		<= Theme $mol_theme_auto
	spreads *
		search <= Search_page $optimade_zero_search
	menu_foot /
		<= Lights $mol_lights_toggle
		<= Sources $mol_link_source
			uri \https://github.com/Lyumih/absolute-zero
